import { JsonObject, JsonProperty } from 'json2typescript';

import SelectedSeatModel from './SelectedSeatModel';

@JsonObject('SeatMapModel')
export default class SeatMapModel {
  @JsonProperty('id', Number) public id:number = undefined;
  @JsonProperty('selected_seats', [SelectedSeatModel], true) public selectedSeats:SelectedSeatModel[] = [];
}
